import { type FunctionComponent } from 'react';

import MultiSelectItem from 'components/MultiSelectItem';
import SelectPanel from 'components/SelectPanel';

import useTranslation from './hooks/useTranslation';

import { DEBOUNCE_DEFAULT_TIME, TEST_ID } from './constants';
import type { Props } from './types';

const MultiSelectPanel: FunctionComponent<Props> = ({
    className = '',
    debounceTime = DEBOUNCE_DEFAULT_TIME,
    entityType,
    hasNextPage,
    isLoading,
    items,
    itemsSelected,
    label,
    noItemsFoundText,
    onFilter,
    onNextPage,
    onToggle,
    testId = TEST_ID
}) => {
    const { CHOOSE_MULTIPLE } = useTranslation();

    return (
        <SelectPanel
            className={className}
            debounceTime={debounceTime}
            hasNextPage={hasNextPage}
            isLoading={isLoading}
            items={items}
            label={label}
            labelText={CHOOSE_MULTIPLE(entityType)}
            noItemsFoundText={noItemsFoundText}
            onFilter={onFilter}
            onNextPage={onNextPage}
            testId={testId}>
            {item => (
                <MultiSelectItem
                    item={item}
                    itemsSelected={itemsSelected}
                    key={item.value}
                    onClick={() => onToggle(item)}
                />
            )}
        </SelectPanel>
    );
};

export default MultiSelectPanel;
